<script>
import axios from "axios";
import Swal from "sweetalert2";
import moment from 'moment'
import Layout from '../layouts/main';
import PageHeader from '@/components/page-header';
import {
  authFackMethods
} from "@/state/helpers";

import {
  required,
  email
} from "vuelidate/lib/validators";

export default {
  page: {
    title: "My Profile",
    meta: [
      {
        name: "My Profile",
      },
    ],
  },
  props: ['id'],
  components: { Layout, PageHeader },
  data() {
    return {
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      userId: null,
      userName: null,
      contactInfoForm: {
        email: "",
        password: "",
        address: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        phone: "",
        city: "",
        state: "",
        zip_code: "",
        age: "",
        gender: "",
        DOB: "",
      },
      typeSubmit: false,
      isLoading: false,
      noRecord: false,
    }
  },
  validations: {
    contactInfoForm: {
      first_name: { required },
      last_name: { required },
      email: { required, email },
      // address: { required },
      // city: { required },
      // state: { required },
      // zip_code: { required, numeric },
      // phone: { required, numeric },
      // age: { required, numeric },
      // gender: { required },
    }
  },
  mounted() {
    this.userId = this.id;
    this.getContactDetail();
  },
  methods: {
    // Getting Current User Information
    getContactDetail() {
      var token = localStorage.getItem('token');
      var config = {
        headers: { Authorization: 'Bearer ' + token }
      };
      if (token) {
        axios.get('admin/users/' + this.userId, config)
          .then((res) => {
            if (res.status == 200) {
              this.contactInfoForm = res.data.response
              this.userName = this.contactInfoForm.username
              this.contactInfoForm.DOB = moment(res.data.response.DOB, 'YYYY-MM-DD').format('YYYY-MM-DD');
            }
          })
          .catch((err) => {
            if (err.response) {
              console.log(err.response.data.error.message)
              if (err.response.status == 401) {
                this.logout();
              }
            }
          })
      }
    },
    ...authFackMethods,

    updateProfile() {
      this.typeSubmit = true;
      this.$v.$touch()
      if (!this.$v.$invalid) {
        var token = localStorage.getItem('token');
        var config = {
          headers: {
            Authorization: 'Bearer ' + token,
          }
        }
        if (token) {
          axios.post('user/update/profile', this.contactInfoForm, config)
            .then((res) => {
              if (res.status == 200) {
                Swal.fire({
                  title: "Success!",
                  text: 'Info Updated Successfully',
                  icon: "success",
                  width: 350,
                  showConfirmButton: true
                });
                this.getContactDetail();
              } else if (res.status == 401) {
                console.log(res.data.response)
              }
            })
            .catch((err) => {
              if (err.response) {
                Swal.fire({
                  title: "Error!",
                  text: err.response.data.error.message,
                  icon: "danger",
                  width: 350,
                  showConfirmButton: true
                });
              }
            })
        }
      }
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="card">
      <div class="card-body">

        <div class="d-flex">
          <div class="me-2">
            <h5 class="card-title mb-3">{{ userName != null ? userName : 'XXX' }} - Profile</h5>
          </div>

        </div>

        <form>

          <div class="row mt-5">

            <div class="col-4 mb-3">
              <label>First Name</label>
              <input
                  type="text" v-model="contactInfoForm.first_name"
                  class="form-control"
                  placeholder="Enter First Name" :class="{
                    'is-invalid': typeSubmit && $v.contactInfoForm.first_name.$error,
                  }"
              />
              <div
                  v-if="typeSubmit && $v.contactInfoForm.first_name.$error"
                  class="invalid-feedback">
              <span v-if="!$v.contactInfoForm.first_name.required"
              >First name is required.</span>
              </div>
            </div>

            <div class="col-4 mb-3">
              <label>Middle Name</label>
              <input
                  type="text" v-model="contactInfoForm.middle_name"
                  class="form-control"
                  placeholder="Enter Middle Name"
              />
            </div>

            <div class="col-4 mb-3">
              <label>Last Name</label>
              <input
                  type="text" v-model="contactInfoForm.last_name"
                  class="form-control"
                  placeholder="Enter Last Name" :class="{
                    'is-invalid': typeSubmit && $v.contactInfoForm.last_name.$error,
                  }"
              />
              <div
                  v-if="typeSubmit && $v.contactInfoForm.last_name.$error"
                  class="invalid-feedback">
              <span v-if="!$v.contactInfoForm.last_name.required"
              >Last name is required.</span>
              </div>
            </div>

            <div class="col-6 mb-3">
              <label>Email Address</label>
              <input
                  type="text" v-model="contactInfoForm.email"
                  class="form-control"
                  placeholder="Enter Email Address"
                  name="email" :class="{
                    'is-invalid': typeSubmit && $v.contactInfoForm.email.$error,
                  }"
              />
              <div
                  v-if="typeSubmit && $v.contactInfoForm.email.$error"
                  class="invalid-feedback">
              <span v-if="!$v.contactInfoForm.email.required"
              >Email is required.</span>
                <span v-if="!$v.contactInfoForm.email.email">Invalid Email.</span>
              </div>
            </div>

            <div class="col-6 mb-3">
              <label>Password</label>
              <input
                  v-model="contactInfoForm.password"
                  type="password"
                  class="form-control"
                  placeholder="******"
                  name="password"
              />
              <span class="text-muted">leave blank if you don't want to update</span>
            </div>

            <div class="col-12 mb-3 d-none">
              <label>Address</label>
              <input
                  type="text" v-model="contactInfoForm.address"
                  class="form-control"
                  placeholder="Enter Address"
                  :class="{
                    'is-invalid': typeSubmit && $v.contactInfoForm.address.$error,
                  }"
              />
              <div
                  v-if="typeSubmit && $v.contactInfoForm.address.$error"
                  class="invalid-feedback">
              <span v-if="!$v.contactInfoForm.address.required"
              >Address is required.</span>
              </div>
            </div>

            <div class="col-4 mb-3 d-none">
              <label>City</label>
              <input v-model="contactInfoForm.city"
                     type="text"
                     class="form-control"
                     placeholder="Enter City"
                     name="city" :class="{
                       'is-invalid': typeSubmit && $v.contactInfoForm.city.$error,
                     }"
              />
              <div
                  v-if="typeSubmit && $v.contactInfoForm.city.$error"
                  class="invalid-feedback">
              <span v-if="!$v.contactInfoForm.city.required"
              >City is required.</span>
              </div>
            </div>

            <div class="col-4 mb-3 d-none">
              <label>State</label>
              <input v-model="contactInfoForm.state"
                     type="text"
                     class="form-control"
                     placeholder="Enter State"
                     name="state" :class="{
                       'is-invalid': typeSubmit && $v.contactInfoForm.state.$error,
                     }"
              />
              <div
                  v-if="typeSubmit && $v.contactInfoForm.state.$error"
                  class="invalid-feedback">
              <span v-if="!$v.contactInfoForm.state.required"
              >State is required.</span>
              </div>
            </div>

            <div class="col-4 mb-3 d-none">
              <label>Zip Code</label>
              <input
                  type="text" v-model="contactInfoForm.zip_code"
                  class="form-control"
                  placeholder="Enter Zip Code"
                  name="zip_code" :class="{
                    'is-invalid': typeSubmit && $v.contactInfoForm.zip_code.$error,
                  }"
              />
              <div
                  v-if="typeSubmit && $v.contactInfoForm.zip_code.$error"
                  class="invalid-feedback">
              <span v-if="!$v.contactInfoForm.zip_code.required"
              >Zip Code is required.</span>
                <span v-if="!$v.contactInfoForm.zip_code.numeric">Enter only Numbers.</span>
              </div>
            </div>

            <div class="col-4 mb-3 d-none">
              <label>Phone Number</label>
              <input
                  type="text" v-model="contactInfoForm.phone"
                  class="form-control"
                  placeholder="Enter Phone Number"
                  name="phone" :class="{
                    'is-invalid': typeSubmit && $v.contactInfoForm.phone.$error,
                  }"
              />
              <div
                  v-if="typeSubmit && $v.contactInfoForm.phone.$error"
                  class="invalid-feedback">
              <span v-if="!$v.contactInfoForm.phone.required"
              >Phone Number is required.</span>
                <span v-if="!$v.contactInfoForm.phone.numeric">Enter only Numbers.</span>
              </div>
            </div>

            <div class="col-2 mb-3 d-none">
              <label>Age</label>
              <input v-model="contactInfoForm.age"
                     type="text"
                     class="form-control"
                     placeholder="Enter Age" :class="{
                       'is-invalid': typeSubmit && $v.contactInfoForm.age.$error,
                     }"
              />
              <div
                  v-if="typeSubmit && $v.contactInfoForm.age.$error"
                  class="invalid-feedback">
              <span v-if="!$v.contactInfoForm.age.required"
              >Age is required.</span>
              </div>
            </div>

            <div class="col-2 mb-3 d-none">
              <label>Gender</label>
              <input v-model="contactInfoForm.gender"
                     type="text"
                     class="form-control"
                     placeholder="Enter Gender" :class="{
                       'is-invalid': typeSubmit && $v.contactInfoForm.gender.$error,
                     }"
              />
              <div
                  v-if="typeSubmit && $v.contactInfoForm.gender.$error"
                  class="invalid-feedback">
              <span v-if="!$v.contactInfoForm.gender.required"
              >Gender is required.</span>
              </div>
            </div>

            <div class="col-4 mb-3 d-none">
              <label>DOB</label>

              <b-form-input
                  v-model="contactInfoForm.DOB"
                  type="date"
              ></b-form-input>

            </div>

          </div>

          <div class="mb-0">
            <div>
              <button type="button" @click="updateProfile" class="btn btn-primary">Update</button>
            </div>
          </div>

        </form>

      </div>
    </div>

  </Layout>
</template>
